import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__invocation_type } from '../../_base/ENUM__invocation_type';
import { INVOCATION_SD__denoise_latents_base } from './INVOCATION_SD__denoise_latents_base';

export class INVOCATION_SD__denoise_latents_pipeline extends INVOCATION_SD__denoise_latents_base {
  /*
   * STATIC FIELDS
   */

  static _class_name_static: string = ENUM__dto_class_name.INVOCATION_SD__DENOISE_LATENTS_PIPELINE;

  /*
   * EVENTS
   */

  /*
   * METHODS
   */

  constructor() {
    super(ENUM__invocation_type.SD__DENOISE_LATENTS_PIPELINE);
  }
}
